/* In the layout's column, under the content: it never covers the song (it used to float over it) */
.bar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1_5);
  min-height: 76px;
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  padding-bottom: calc(var(--tuna-spacing-1) + env(safe-area-inset-bottom, 0px));
  background-color: var(--tuna-palette-background-paper);
  border-top: 1px solid var(--tuna-palette-divider);
  box-sizing: border-box;
}

/* Phones: 68px, the thumb row */
@media (max-width: 599.95px) {
  .bar {
    min-height: 68px;
    gap: var(--tuna-spacing-0_5);
    padding: var(--tuna-spacing-0_5) var(--tuna-spacing-1);
    padding-bottom: calc(var(--tuna-spacing-0_5) + env(safe-area-inset-bottom, 0px));
  }

  .time {
    gap: var(--tuna-spacing-0_5);
  }
}

.time {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: var(--tuna-spacing-1_5);
  min-width: 0;
}

.set {
  display: flex;
  flex: 0 1 auto;
  justify-content: flex-end;
  min-width: 0;
}

.set:empty {
  display: none;
}

/* Stage-sized touch targets: at least 48px */
.target,
.time :global(button) {
  min-height: var(--tuna-spacing-6);
  min-width: var(--tuna-spacing-6);
}

/* Sentence case, like the Perform header ("+ Jot", "My notes") */
.bar :global(button) {
  text-transform: none;
}

.autoscroll {
  border-radius: var(--tuna-shape-radius-pill);
  white-space: nowrap;
}

.duration {
  margin-left: var(--tuna-spacing-1);
  font-variant-numeric: tabular-nums;
  font-weight: 500;
}
